import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/logout.svg';


export default (props: SVGProps<any>) => <ReactComponent {...props} />;
